import React from 'react';

interface BasicTablePaginatorProps {
  pageIndex: number;
  pageCount: number;
  canPreviousPage: boolean;
  canNextPage: boolean;
  onPreviousPage: () => void;
  onNextPage: () => void;
}

const BasicTablePaginator: React.FC<BasicTablePaginatorProps> = ({
  pageIndex,
  pageCount,
  canPreviousPage,
  canNextPage,
  onPreviousPage,
  onNextPage,
}) => {
  if (pageCount <= 1) return null;

  return (
    <div className="flex justify-end items-center gap-4 px-4 py-2">
      <button
        onClick={onPreviousPage}
        disabled={!canPreviousPage}
        className={`rounded px-3 py-1 text-sm font-medium transition
          ${
            canPreviousPage
              ? 'bg-primary text-white hover:bg-primary/90 dark:hover:bg-primary/80'
              : 'bg-blue-100 text-blue-400 dark:bg-blue-900 dark:text-blue-500'
          }`}
      >
        Anterior
      </button>

      <span className="text-sm text-gray-600 dark:text-gray-300">
        Página {pageIndex + 1} de {pageCount}
      </span>

      <button
        onClick={onNextPage}
        disabled={!canNextPage}
        className={`rounded px-3 py-1 text-sm font-medium transition
          ${
            canNextPage
              ? 'bg-primary text-white hover:bg-primary/90 dark:hover:bg-primary/80'
              : 'bg-blue-100 text-blue-400 dark:bg-blue-900 dark:text-blue-500'
          }`}
      >
        Siguiente
      </button>
    </div>
  );
};

export default BasicTablePaginator;
